import { render, staticRenderFns } from "./ReportCardItem.vue?vue&type=template&id=058f5482&scoped=true&"
import script from "./ReportCardItem.vue?vue&type=script&lang=ts&"
export * from "./ReportCardItem.vue?vue&type=script&lang=ts&"
import style0 from "./ReportCardItem.vue?vue&type=style&index=0&id=058f5482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f5482",
  null
  
)

export default component.exports